import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PA_BY_PLACEMENT_ATTRIBUTED } from "../keys";

const usePAByPlacementAttributed = ({ sponsorObjectId = 0, rightsholderId = 0, parentTenantId = null } = {}) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const enabled = !!(startDate && endDate);

  let since, until;
  if (enabled) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [PA_BY_PLACEMENT_ATTRIBUTED, tenant.id, sponsorObjectId, rightsholderId, parentTenantId, startDate, endDate],
    queryFn: () => ApiService.getPlacementAnalysisByPlacementAttributed({
      sponsorObjectId,
      rightsholderId,
      parentTenantId,
      since,
      until,
    }),
    select: (data) => data.data,
    enabled,
    placeholderData: { data: { data: [], total_media_value: 0, total_duration_seconds: 0 } },
  });
};

export default usePAByPlacementAttributed;
